
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Gift, Star, Heart } from "lucide-react";

interface PromotionalCardProps {
  title: string;
  description: string;
  icon: "gift" | "star" | "heart";
  actionLabel: string;
  onClick: () => void;
}

const PromotionalCard = ({
  title,
  description,
  icon,
  actionLabel,
  onClick,
}: PromotionalCardProps) => {
  const getIcon = () => {
    switch (icon) {
      case "gift":
        return <Gift className="h-5 w-5 sm:h-6 sm:w-6 text-primary" />;
      case "star":
        return <Star className="h-5 w-5 sm:h-6 sm:w-6 text-primary" />;
      case "heart":
        return <Heart className="h-5 w-5 sm:h-6 sm:w-6 text-primary" />;
    }
  };

  return (
    <Card className="p-4 sm:p-6 bg-white hover:shadow-md transition-all duration-200 border border-[#E5DEFF] hover:border-primary animate-scale-up">
      <div className="flex flex-col space-y-3 sm:space-y-4">
        <div className="p-2 bg-[#F1F0FB] rounded-lg w-fit">
          {getIcon()}
        </div>
        <h3 className="text-base sm:text-lg font-semibold text-[#1A1F2C]">{title}</h3>
        <p className="text-sm text-[#8E9196] flex-grow">{description}</p>
        <Button 
          onClick={onClick}
          className="w-full bg-primary hover:bg-primary/90 text-white text-sm sm:text-base"
        >
          {actionLabel}
        </Button>
      </div>
    </Card>
  );
};

export default PromotionalCard;
